import { CreateContractPageContent } from "./CreateContractPage";
import BenefitList from "../../shared/elements/BenefitList";
import { SIMPLE_BENEFITS } from "../contract-type/SimpleCard";
import { ContractType } from "../model/ContractViewModel";

export default function CreateSimpleContractPage() {
  return (
    <CreateContractPageContent
      title="Opprett enkel kjøpekontrakt"
      contractType={ContractType.Simple}
    >
      <BenefitList benefits={SIMPLE_BENEFITS} />
    </CreateContractPageContent>
  );
}
